import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { ModelID } from '@/types';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { InspectionSearchParams, featureKeys, featurePath } from '.';
import { Inspection } from '@/types';

type QueryFnType = typeof findInspection;

type UseInspectionOptions = {
  id: ModelID;
  search?: InspectionSearchParams;
  config?: QueryConfig<QueryFnType>;
};

const findInspection = (id: ModelID, search: any = {}) => get<Inspection>(`${featurePath}/${id}`, search);

export const useInspection = ({ id, search = {}, config = {} }: UseInspectionOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: featureKeys.detail(+id),
    queryFn: () => findInspection(id, search),
  });
};
